// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h5XnL","rootMobile":"styles_rootMobile__2voOi"};